import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Calendar } from '@phosphor-icons/react'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'

const TYPE = 'scheduleMeeting'
// The chip swaps to Calendar for calendar providers; the catalog icon is the default.
const DEFAULT_ICON = nodeIcon(TYPE)

const PROVIDER_LABELS: Record<string, string> = {
  zoom: 'Zoom',
  google_calendar: 'Google Cal',
  outlook_calendar: 'Outlook Cal',
  calendly: 'Calendly',
}

const ScheduleMeetingNode: React.FC<NodeProps> = ({ data, selected }) => {
  const provider = data.schedule_meeting_config?.provider || 'zoom'
  const duration = data.schedule_meeting_config?.duration || 30
  const isCalendar = provider === 'google_calendar' || provider === 'outlook_calendar'
  const Icon = isCalendar ? Calendar : DEFAULT_ICON
  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle type="target" position={Position.Top} className={nodeHandleClass(TYPE)} />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Meeting</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Schedule Meeting'}</p>
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground pl-10">
        {PROVIDER_LABELS[provider] || provider}{provider !== 'calendly' ? ` · ${duration} min` : ''}
      </p>
      <Handle type="source" position={Position.Bottom} className={nodeHandleClass(TYPE)} />
    </div>
  )
}

export default memo(ScheduleMeetingNode)
